module.exports = __webpack_public_path__ + "img/3d-tablet_cn.a716de5.jpg";